import React, { Component, PropTypes } from 'react';
import { Field } from 'redux-form';
import idx from 'idx';
import {
  TextInputField, TextAreaField, PasswordInputField, RadioButtonField
} from 'common/components/form_fields';
import ModalDialog from 'common/components/modal/modal_dialog';
import IntroPreview from 'presentations/components/intro_preview';

export default class AddStepIntro extends Component {
  constructor(props) {
    super(props);

    this.state = { introPreviewFull: false };
    this.toggleFullIntroPreview = this.toggleFullIntroPreview.bind(this);
  }

  toggleFullIntroPreview() {
    this.setState({ introPreviewFull: !this.state.introPreviewFull });
  }

  renderIntroPreview() {
    const { values } = this.props;

    return (
      <IntroPreview logo={idx(values, _ => _.logo.preview)}
        purpose={values.purpose}
        primaryColor={
          values.use_standard_colors? undefined : values.custom_primary_color
        } />
    );
  }

  render() {
    const { introPreviewFull } = this.state;

    return (
      <div>
        <fieldset>
          <div className="row">
            <div className="columns medium-8">
              <h3>Name Your Presentation Site</h3>
              <p>The name is only visible to you and your collaborators on crowdspring.</p>
              <Field name="name" label="Presentation Name" component={TextInputField} />
            </div>
          </div>
        </fieldset>
        <fieldset>
          <div className="row">
            <div className="columns medium-6 small-16">
              <h3>Message to Participants</h3>
              <p>
                Tell participants what you need them to do (i.e. "Please score these designs and comment
                on what you like/don't like about each"). This message will appear at the top
                of the gallery on the presentation site.
              </p>
              <Field name="purpose" component={TextAreaField} rows={5}/>
            </div>
            <div className="columns medium-10 small-16 preview-wrapper">
              <h3>Preview</h3>
              <ModalDialog modalOpen={introPreviewFull} closeAction={this.toggleFullIntroPreview}
                  modalHeader="Preview" dialogClasses="intro-preview-modal" contentClasses="wide"
                  onPrimary={this.toggleFullIntroPreview} primaryLabel="Done">
                { this.renderIntroPreview() }
              </ModalDialog>
              { this.renderIntroPreview() }
            </div>
          </div>
        </fieldset>
        <fieldset>
          <div className="row">
            <div className="columns medium-8">
              <h3>URL</h3>
              <p>Pick your custom subdomain (i.e. brightagency.pickfavorite.com)</p>
              <Field name="sub_domain" component={TextInputField} preValue="https://"
                postValue=".pickfavorite.com" />
            </div>
          </div>
        </fieldset>
        <fieldset>
          <div className="row">
            <div className="columns medium-8">
              <h3>Set a Presentation Site Password</h3>
              <p>
                People must have a password to view your presentation site. We'll include the password
                in the invitations to each participant.
              </p>
              <Field name="password" component={PasswordInputField} showVisibilityToggle={true} />
            </div>
          </div>
        </fieldset>
        <fieldset>
          <div className="row">
            <div className="columns medium-8">
              <h3>Share Results</h3>
              <p>Should participants see the results of the voting after participating?</p>
              <Field name="share_results" component={RadioButtonField}
                props={{ value: true }}
                label="Yes"
              />
              <Field name="share_results" component={RadioButtonField}
                props={{ value: false }}
                label="No"
              />
            </div>
          </div>
        </fieldset>
      </div>
    );
  }
}

AddStepIntro.propTypes = {
  values: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./presentations/components/add_step_intro.jsx